import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Col, Row, Rate, Typography, Tooltip } from "antd";
import { InfoCircleOutlined, CheckCircleOutlined } from "@ant-design/icons";
import InfoIcon from "../../../../../assets/icons/InfoIcon.svg";

import { BsFillEyeFill } from "react-icons/bs";
import { DefaultRating } from "../../../../../assets/helpers";
import ps_suitcase from "../../../../../assets/img/ps_suitcase.svg";
import { formatDate, isNonHC } from "../../../../../shared/helpers";
import history from "../../../../../routes/history";
import "./RequestedCards.css";

const { Text } = Typography;

function RequestedCards({ isInvitedTalent = false, SkillListingId, ...props }) {
  const [profilePic, setProfilePic] = useState("");
  const [candidateTitle, setCandidateTitle] = useState(null);
  const [imageError, setImageError] = useState(false);
  const [visible, setVisible] = useState(false);
  const truncateTooltipTitle =
  props?.Title?.length > 100 ?
  props?.Title.slice(0, 100) + "..." :
  props?.Title;
  const truncateTitle =
  props?.Title?.length > 20 ?
  props?.Title.slice(0, 20) + "..." :
  props?.Title;
  useEffect(async () => {
    if (props?.PictureUrl) {
      setProfilePic(props?.PictureUrl);
    }
  }, [props]);

  const capitalizeFirst = (str) => {
    return str?.charAt(0).toUpperCase() + str?.slice(1);
  };
  let budgetName = props?.BudgetName;
  if (budgetName && budgetName.includes('Hour')) {
    budgetName = budgetName.replace('Hour', 'HR');
  } else
  if (budgetName && budgetName.includes('Year')) {
    budgetName = budgetName.replace('Year', 'YR');
  } else

  {
    budgetName = '';
  }

  useEffect(() => {
    setCandidateTitle(
    capitalizeFirst(props?.items?.users?.Profiles?.FirstName?.split("")[0]));

  }, [props.UserName]);

  const detailsPage = () => {
    history.push({
      pathname: `/invitedTalent/${SkillListingId}`,
      state: {
        id: SkillListingId,
        Rating: props?.Rating,
        token: "valid",
        isInvited: true
      }
    });
  };

  const handleClick = (e) => {
    setVisible((prev) => !prev);
  };

  return (
    <>
      <div
      className="requestedCard"
      onClick={detailsPage}>
        
        <div
        style={{
          minHeight: "280px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between"
        }}>
          
          <Row className="image-div">
            <div className="image-circle">
              {
              profilePic &&
              !imageError &&
              profilePic?.split("/")?.pop() !== "no-pic.png" ?
              <img
              className="dp"
              alt=""
              src={`${process.env.REACT_APP_S3_URL}${
              profilePic?.charAt(0) !== "/" ? "/" : ""
              }${profilePic}`}
              onError={() => {
                setImageError(true);
              }} /> :


              <div className="dp-text">
                    {props?.items?.users?.Profiles?.FirstName ?
                candidateTitle :
                "C"}
                  </div>}

              
            </div>
            {props.prevviewed ?
            <BsFillEyeFill
            style={{
              marginLeft: "80%",
              color: "#7e7e7e",
              position: "absolute"
            }} /> :

            null}
          </Row>
          <div className="card-details-column">
            <div className="nameofcandidate">
              {props?.items?.users?.Profiles?.FirstName ?
              `${props.items.users.Profiles.FirstName} ${props.items.users.Profiles.LastName}` :
              props.items?.users?.UserName ?? "Candidate name"}
            </div>
            <div className="rating-value-alignment">
              <Rate
              allowHalf
              className="card-ratings"
              disabled
              defaultValue={
              props.Rating == null ||
              props.Rating == "" ||
              props.Rating == undefined ?
              DefaultRating :
              parseFloat(props.Rating)}

              style={{
                color: "#ffba08"
              }} />
              
              <Text className="card-ratings-value">
                <span
                style={{
                  color: "#ffba08",
                  fontSize: "12px",
                  whiteSpace: "nowrap"
                }}>
                  
                  {props.Rating === 0 || props.Rating === null ?
                  DefaultRating :
                  props.Rating}
                </span>{" "}
                {props?.Reviews ? `(${props?.Reviews})` : null}
              </Text>
            </div>
            {props.Title ?
            <div>
                <Tooltip
              title={truncateTooltipTitle}
              overlayInnerStyle={{ maxWidth: "200px", height: "auto" }}
              trigger={["click", "hover"]}
              mouseLeaveDelay={0}>

                
                  <span
                className="card-title"
                onClick={(e) => e.stopPropagation()}>
                  
                    {truncateTitle}
                  </span>
                </Tooltip>
              </div> :

            <div style={{ height: "30px" }}></div>}
            
            {
            <div className="card-desired-rate">
                <Text className="card-desiredrate-text">
                  {!isNonHC(props.professionCode) ?
                "Desired rate" :
                "Est. Amount"}
                </Text>
                {!isNonHC(props.professionCode) ?
              isInvitedTalent ?
              props?.ClientRate ?
              "$" + props?.ClientRate :
              "$Negotiable" :
              props?.MinimumBid === null || props?.MinimumBid === null ?
              "$Negotiable" :
              props?.MinimumBid ?
              typeof props?.MinimumBid === "object" ?
              "$" + Math.floor(props?.MinimumBid?.$numberDecimal) :
              "$" + props?.skill_listings?.MinimumBid :
              "$" + props.MinimumBid ?
              typeof props?.MinimumBid === "object" ?
              "$" + Math.floor(props?.MinimumBid?.$numberDecimal) :
              "$" + props?.MinimumBid :
              "$Negotiable" :
              isInvitedTalent ?
              props?.ClientRate ?
              "$" + props?.ClientRate :
              "$Negotiable" :
              props?.data?.skill_listings?.ClientRate != null ||
              props?.ClientRate != null ||
              props?.ClientRate != undefined ?
              props?.ClientRate ?
              "$" + parseFloat(props?.ClientRate)?.toFixed(2) :
              "$" + props?.ClientRate?.toFixed(2) :
              "$Negotiable"}/
                  {budgetName}

                {/* {!isNonHC(props.professionCode)
                ? isInvitedTalent
                  ? [null, undefined, "", "null"].includes(props?.ClientRate)
                    ? ""
                    : "/" + props?.BudgetTypes?.BudgetTypeName || ""
                  : props?.skill_listings?.MinimumBid === null ||
                    props?.MinimumBid === null
                  ? ""
                  : props?.BudgetTypes
                  ? "/" + props?.BudgetTypes?.BudgetTypeName
                  : props?.skill_listings?.BudgetTypes
                  ? "/" + props?.skill_listings?.BudgetTypes?.BudgetTypeName
                  : props?.skill_listings?.MinimumBidType
                  ? "/" + props?.skill_listings?.MinimumBidType
                  : props?.MinimumBidType && "/" + props?.MinimumBidType
                : props?.skill_listings?.ClientRate === null ||
                  props?.ClientRate === null
                ? ""
                : isInvitedTalent
                ? [null, undefined].includes(props?.ClientRate)
                  ? ""
                  : "/a" + props?.BudgetTypes?.BudgetTypeName || ""
                : props?.BudgetTypes
                ? "/" + props?.BudgetTypes?.BudgetTypeName
                : props?.skill_listings?.BudgetTypes
                ? "/" + props?.skill_listings?.BudgetTypes?.BudgetTypeName
                : props?.skill_listings?.MinimumBidType
                ? "/" + props?.skill_listings?.MinimumBidType
                : props?.MinimumBidType && "/" + props?.MinimumBidType} */}
              </div>}
            
            <Row
            style={{
              height: "2.6rem",
              // width: windowDimensions.width < 540 && "9rem",
              marginLeft: "auto",
              marginRight: "auto",
              textAlign: "center",
              marginTop: "2px"
            }}>
              
              <Col
              lg={20}
              xs={24}
              style={{
                color: "#3e3e3e",
                fontSize: "12px",
                fontWeight: "500",
                margin: "auto",
                borderColor: "#118936"
              }}>
                
                <img src={ps_suitcase} alt="" />
                {
                <Text style={{ marginLeft: "2px" }}>
                    {props?.Experience ?
                  " " + props?.Experience + " Years of experience" :
                  " N/A"}
                  </Text>}
                
              </Col>
            </Row>

            {props.isInvitation ?
            <div className="invitationContainer">
                Invitation not accepted
                <Tooltip
              className="tooltipStyle"
              title={
              <div
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}>
                
                      <strong>Info</strong>
                      <div style={{ borderBottom: "1px solid grey" }}></div>
                      <div>
                        Invite sent by{" "}
                        <strong>
                          {props.EmployerName ? props.EmployerName : "N/A"}
                        </strong>{" "}
                        from <br />
                        {props.EmployerEmail}{" "}
                        {formatDate(props.InvitedDate) || "N/A"}
                      </div>
                    </div>}

              placement="bottom"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}>
                
                <img alt="" src={InfoIcon} style={{ marginLeft: "10px" }} />
                </Tooltip>
              </div> :

            ""}
            
          </div>
        </div>
      </div>
    </>);

}

export default RequestedCards;